import React, {useEffect, useReducer, useState} from 'react'
import ProductGeneralTab from './edit-product/ProductGeneralTab'
import {fieldReducer, productActionType, productInitialState, productState} from './cors/reducers'
import SharedData from '../common/SharedData'
import {getProduct, getRequestDataToEdit} from './cors/_requests'
import Loader from '../common/Loader'
import {useNavigate, useParams} from 'react-router-dom'
import { useIntl } from 'react-intl'
import '../../stylesheet/RejctionTag.css'
import {toAbsoluteUrl} from "../../../_metronic/helpers";
import '../../modules/reports/payment-video.css'
import './add-product/add-single-product.css'

const EditProduct = () => {
  const {formatMessage} = useIntl()
  const {currentUser, language} = SharedData()
  let {productID} = useParams()
  const navigate = useNavigate()
  const [state, dispatch] = useReducer(fieldReducer, productInitialState)
  const [rejectionReason, setRejectionReason] = useState('')
  const [showVideoHighlight, setShowVideoHighlight] = useState(false);
  const [saveSignal, setSaveSignal] = useState(0)
  const [submitting, setSubmitting] = useState(false)
  const toggleRenderLoadFlag = () => {
    dispatch({type: productActionType.isLoading})
    dispatch({type: productActionType.isRendering})
  }

  useEffect(() => {

    const getData = async () => {
      toggleRenderLoadFlag()

      if (!(productID?.includes('&'))){
        try {
          const data = await getProduct(productID || '', language, currentUser?.token)
          if (data) {
            dispatch({
              type: productActionType.fillProductData,
              payload: {id: '', value: '', ...data.data, product_specials: data.data.product_specials },
            })
          }
        } catch (err: any) {
          // Multi-supplier: the catalog edit form is now open to any
          // supplier with an active offer on the product (see Lumen
          // ProductController::supplierCanEditProduct). A 400 here
          // means the product doesn't exist or the supplier has no
          // active offer — surface that to the user rather than the
          // raw axios error.
          if (err?.response?.status === 400) {
            navigate('/products/list', {replace: true})
            return
          }
          throw err
        } finally {
          toggleRenderLoadFlag()
        }
      }
    }

    const getRequestData = async () => {
      if (!productID) return
      toggleRenderLoadFlag()
      try {
        const requestId = productID.match(/(\d+)(?=&|$)/)?.[1] ?? productID
        const suffix = productID.match(/&(.+)/)?.[1]
        // Drafts open as 'add' (&draft); real edit-requests reach this page
        // via /requests/edit -> &edit, so still derive the type from the suffix.
        const requestType = suffix === 'draft' ? 'add' : (suffix || 'edit')

        const data = await getRequestDataToEdit(requestId, requestType, language, currentUser?.token)

        if (data?.data?.rejection_reason) {
          setRejectionReason(data.data.rejection_reason);
        }
        if (data) {
          dispatch({
            type: productActionType.fillProductData,
            payload: {id: '', value: '', ...data.data, product_specials: data.data.product_specials},
          })
        }
      } catch (err) {
        // The request genuinely can't be loaded — return to the list instead
        // of letting the rejection crash the page.
        console.error('Failed to load draft for edit', err)
        navigate('/products/drafted-list', {replace: true})
      } finally {
        toggleRenderLoadFlag()
      }
    }
    if (productID && productID.includes('&')) getRequestData()
    else if (productID && !productID.includes('&')) getData()

  }, [productID, language, currentUser?.token]);

  useEffect(() => {
    const hasSeenVideo = document.cookie
      .split(';')
      .some(item => item.trim().startsWith('add_product_video='));

    setShowVideoHighlight(!hasSeenVideo);
  }, []);

  // Paint the content canvas in the design's page colour (#F7F8FA) while this
  // page is mounted; restore it on unmount so other pages are unaffected.
  useEffect(() => {
    const el = document.getElementById('kt_app_content')
    el?.classList.add('aps-page-bg')
    return () => el?.classList.remove('aps-page-bg')
  }, []);
  return (
    <div className='aps-root position-relative add-product-page'>
      <div className='aps-header'>
        <h2 className='aps-title'>
          {productID
            ? formatMessage({id: 'edit_single_prod'})
            : formatMessage({id: 'add_single_prod'})}
        </h2>
        <button
          type="button"
          className="aps-save-btn"
          onClick={() => setSaveSignal((s) => s + 1)}
          disabled={submitting}
        >
          {formatMessage({id: 'save_changes'}) || formatMessage({id: 'submit'})}
        </button>
      </div>

      {rejectionReason && (
          <div className="rejection-reason-box">
            <img
                style={{padding: '0px 5px'}}
                width="25"
                src={toAbsoluteUrl('/media/logos/error.svg')}
            />
            <span className='fw-bold'>
              {formatMessage({id: 'rejection_reason'})}:
            </span>
            <span className="rejection-text"> {rejectionReason} </span>
          </div>
      )}

      <ProductGeneralTab prodState={state} prodDispatch={dispatch} saveSignal={saveSignal} onSubmittingChange={setSubmitting} />

      {state.isLoading && <Loader isFull={true} />}
    </div>
  )
}

export default EditProduct
